// extracted by mini-css-extract-plugin
export default {"FailureModalContent":"FailureModalContent_FailureModalContent__1S+IM","Buttons":"FailureModalContent_Buttons__MNVVh","Button":"FailureModalContent_Button__3daa6"};